function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawMarketing = function UndrawMarketing(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 965.245 817.223",
    style: style
  }, props), React.createElement("path", {
    d: "M517.293 755.938C274.895 737.49-14.177 549.672.54 356.28S295.226-17.142 537.625 1.305 919.557 381.167 904.84 574.558s-145.148 199.827-387.547 181.38z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M1.245 71.008h460v476h-460z"
  }), React.createElement("path", {
    d: "M233.523 213.037a97.785 97.785 0 0 0-2.278-.03 95.95 95.95 0 1 0 84.444 50.298l-79.444 59.703z",
    fill: "none"
  }), React.createElement("path", {
    d: "M315.689 263.305a96.013 96.013 0 1 1-84.444-50.297c.762 0 1.521.01 2.278.029l-1.015-41.013c-.421-.004-.84-.016-1.263-.016a136.96 136.96 0 1 0 117.471 66.476z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M315.689 263.305l33.027-24.821a136.92 136.92 0 0 0-116.208-66.46l1.015 41.013a95.986 95.986 0 0 1 82.166 50.268z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M300.136 427.444l48.109 48.564M332.909 129.915l-33.437 59.622"
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M309.245 476.008h79v18h-79zM291.245 112.008h79v18h-79z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M505.245 67.008h460v192h-460z"
  }), React.createElement("path", {
    d: "M691.076 215.008h-52a181.872 181.872 0 0 1 0-62h52a111.559 111.559 0 0 0 0 62zM836.407 215.008h-52a181.872 181.872 0 0 1 0-62h52a111.559 111.559 0 0 0 0 62z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M617.245 173.008h-52a181.872 181.872 0 0 1 0-62h52a111.559 111.559 0 0 0 0 62zM710.245 173.008h52a181.872 181.872 0 0 0 0-62h-52a111.559 111.559 0 0 1 0 62zM853.245 173.008h52a181.872 181.872 0 0 0 0-62h-52a111.559 111.559 0 0 1 0 62z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M877.245 758.008c0 19.941-93.177 59.215-207.5 59.215s-206.5-39.274-206.5-59.215 92.178-13 206.5-13 207.5-6.942 207.5 13z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M877.245 758.008c0 19.941-93.177 59.215-207.5 59.215s-206.5-39.274-206.5-59.215 92.178-13 206.5-13 207.5-6.942 207.5 13z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 669.745,
    cy: 758.115,
    rx: 207,
    ry: 36.108,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 669.745,
    cy: 758.115,
    rx: 162,
    ry: 28.258,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M598.245 544.008h-52a181.872 181.872 0 0 1 0-62h52a111.559 111.559 0 0 0 0 62z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M762.762 230.055l7.15 3.576s38.735 97.132 25.625 120.372-54.227 66.74-54.227 66.74l-7.747-22.048 31.682-68.687z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M762.762 230.055l7.15 3.576s38.735 97.132 25.625 120.372-54.227 66.74-54.227 66.74l-7.747-22.048 31.682-68.687z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M755.015 715.715s10.13 23.24 4.768 25.028-11.918 1.788-18.473 1.788-14.302-2.384-15.494-4.767 4.767-17.877 4.767-17.877zM618.554 727.633s6.555 20.857 3.575 22.049-12.514 6.555-17.877 4.767-13.706-5.959-15.493-7.747 0-11.322 0-11.322l8.342-11.918z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M735.946 417.764l8.542 2.98s2.185 20.26-.199 27.411-7.747 58.995-4.767 69.72 1.192 28.008 1.192 28.008 17.877 58.399 14.301 70.913-2.98 30.39.596 39.33 6.555 12.513 4.767 19.664-5.363 10.726-1.787 16.685 10.726 7.747 7.15 13.11-7.15 9.534-5.958 13.11-31.583 10.13-34.563 4.767c0 0 9.535-8.343 0-13.11s-6.555-22.644-6.555-22.644-16.685-68.529-16.089-73.892-26.22-88.79-26.22-88.79-39.33 119.181-41.713 124.544 2.98 18.473 0 22.049 1.192 12.514-2.98 16.089 7.151 16.685 0 21.452-10.726 19.665-10.13 22.645-29.795-.596-29.795-4.767.596-7.747-2.383-14.898-4.768-11.918-2.384-14.302 4.171-5.363 1.788-13.705 3.575-33.967 1.787-38.734-1.191-36.946-1.191-36.946 5.959-47.076 4.17-54.823 0-9.534.597-12.514 4.171-35.158 6.555-39.925 5.363-86.406 19.069-90.577 116.2 7.15 116.2 7.15z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M740.714 737.168s21.452-3.576 22.644 0 4.767 31.583-3.575 32.179-22.645 2.383-25.028-2.98-13.706-8.938-13.706-8.938-16.685-4.768-16.685-10.13.596-13.707 3.575-14.302 14.898-7.151 14.898-9.535 17.877 13.706 17.877 13.706zM606.636 746.702s15.493-4.767 19.069-1.787 8.342 35.754 0 35.158-30.391 2.98-31.583-1.788-17.281-5.959-17.281-5.959-17.282-8.343-16.09-17.281 2.98-11.918 10.13-12.514 12.515-8.939 13.11-9.534 5.85-4.952 6.5-.093 8.398 15.586 16.145 13.798z",
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 655.5,
    cy: 132.923,
    r: 36.35,
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M687.083 141.266s2.383 39.925 11.322 43.5-45.289 3.576-45.289 3.576-.596-25.028-8.343-30.987 42.31-16.09 42.31-16.09z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M701.384 175.828s-36.946-13.706-50.056 7.747c0 0-41.713 19.665-44.692 31.583s25.028 101.303 25.028 101.303 0 73.892-5.96 81.639-17.28 16.089-9.534 17.877 129.31 14.897 128.715 7.15-8.343-14.301 0-19.068 1.192-10.13 6.555-25.624 18.473-143.613 18.473-143.613-8.939-16.089-10.726-17.877-57.803-41.117-57.803-41.117z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M594.718 436.833s-23.24 52.44-2.98 59.59 19.07-55.418 19.07-55.418z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M672.936 139.684c-2.107-4.222-5.261-9.093-9.973-8.836-2.382.13-4.437 1.613-6.56 2.7s-4.844 1.763-6.785.377c-2.84-2.029-1.96-6.84-4.5-9.233-2.773-2.613-8.35-1.154-10.14-4.518-.954-1.796-.183-4.024-.6-6.015-2.902.055-5.897.093-8.588-.998s-5.02-3.617-4.944-6.519a7.456 7.456 0 0 1 2.662-5.127c3.663-3.33 8.962-3.97 13.482-5.99 3.598-1.607 6.726-4.112 10.261-5.851 6.085-2.993 13.106-3.574 19.867-3.057 10.252.784 20.62 4.186 28.055 11.289s11.369 18.309 8.162 28.078c-1.817 5.536-5.667 10.189-7.816 15.605a54.622 54.622 0 0 0-2.723 11.445l-1.508 9.256c.234-1.44-2.928-5.053-3.966-5.913-2.262-1.875-5.553-1.239-7.653-2.976-3.107-2.57-4.905-10.055-6.733-13.717z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M620.341 210.986l-9.534 5.96s-15.493 93.556-13.706 106.666-7.15 87.002-4.171 92.96 4.171 7.151 4.171 10.727-8.342 16.685-2.98 19.069 25.029 6.555 25.029 0-3.576-15.494 2.98-19.665 11.321-30.987 11.321-30.987 2.98-27.412 5.96-32.775 7.15-25.028 7.15-33.37 7.151-42.31 2.98-59.59-5.363-63.762-29.2-58.995z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M616.17 209.199l-9.534 5.959s-15.494 93.556-13.706 106.666-7.15 87.002-4.171 92.96 4.171 7.152 4.171 10.727-8.343 16.685-2.98 19.069 25.028 6.555 25.028 0-3.575-15.494 2.98-19.665 11.322-30.987 11.322-30.987 2.98-27.411 5.959-32.774 7.15-25.028 7.15-33.37 7.152-42.31 2.98-59.591-5.363-63.762-29.199-58.994z",
    fill: "#575a89"
  }));
};
UndrawMarketing.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawMarketing;